// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ns-c";
export var backButton = "_ns-4";
export var backIcon = "_ns-5";
export var chevronShortcut = "_ns-6";
export var container = "_ns-1";
export var editor = "_ns-8";
export var editorWrapper = "_ns-7";
export var prefix = "_ns-2";
export var searchIcon = "_ns-3";
export var suffix = "_ns-9";
export var suffixContent = "_ns-a";
export var suffixText = "_ns-b";
export var wrapper = "_ns-0";